<h3>
    <a ng-click="viewDetails($event, item)" ng-bind-html="item.Title|cHighlight:highlight"></a> <span ng-if="item.Updated" class="fa fa-check" style="color: green"></span> <span ng-if="item.Escalated" class="fa fa-warning" style="color: red" title="{{'task.Escalated'|translate}}"></span>
</h3>
<div ng-if="item.Description" class="item-excerpt">{{item.Description}}</div>
<div class="property-container">
    <ul class="workflow-property-list">
        <li>{{ item.TaskStatus.text }}</li>
        <li>{{'task.startDate'|translate}}: {{ item.StartDate | cDate }}</li>
        <li ng-if="item.EndDate">{{'task.endDate'|translate}}: {{ item.EndDate | cDate }}</li>
        <li ng-if="item.Workflow">{{ item.Workflow.DisplayText }}</li>
        <li>{{'properties.owner'|translate}}: {{ item.Owner.DisplayName }}</li>
        <li ng-if="item.assignedTo.length > 0">{{ 'properties.assignedTo'|translate}}: {{ item.AssignedTo }}</li>
        <li ng-if="item.assignedTo.length === 0">{{ 'properties.unassigned'|translate}}</li>
        <li ng-if="item.Priority">{{ 'task.priority'|translate}}: {{'task.Priority.' + item.Priority | translate}}</li>
    </ul>
</div>